export default [
	{ id: '1', imageName: 'v1.jpeg', tag: 'Support Farmers' },
	{ id: '2', imageName: 'v3.jpeg', tag: 'Support Farmers' },
	{ id: '3', imageName: 'pic14.jpeg', tag: 'Support Farmers' },
	{ id: '4', imageName: 'v2.jpeg', tag: 'Support Farmers' },
	{ id: '5', imageName: 'pic1.jpg', tag: 'Women Empowerment' },
	{ id: '6', imageName: 'pic2.jpg', tag: 'Women Empowerment' },
	{ id: '7', imageName: 'pic4.jpg', tag: 'Women Empowerment' },
	{ id: '8', imageName: 'pic5.jpg', tag: 'Support Farmers' },
	{ id: '9', imageName: 'pic6.jpg', tag: 'Support Farmers' },
	{ id: '10', imageName: 'pic7.jpg', tag: 'Support Farmers' },
	{ id: '11', imageName: 'pic8.jpg', tag: 'Support Farmers' },
	{ id: '12', imageName: 'pic9.jpg', tag: 'Pregnant Women' },
	{ id: '13', imageName: 'pic10.jpg', tag: 'Pregnant Women' },
	{ id: '14', imageName: 'pic13.jpeg', tag: 'Support Farmers' },
	{ id: '15', imageName: 'pic15.jpeg', tag: 'Support Farmers' },

];
